import { render, staticRenderFns } from "./RecommendAgent.vue?vue&type=template&id=e113648c&scoped=true&"
import script from "./RecommendAgent.vue?vue&type=script&lang=js&"
export * from "./RecommendAgent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendAgent.vue?vue&type=style&index=0&id=e113648c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e113648c",
  null
  
)

export default component.exports